var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoConversationsIllustration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 284 66",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-813 -456)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(696 456)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(117)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(36 34)",
    fill: "#1C363C"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    d: "m19.846 27.94-3.0657 3.4087c-0.7805 0.86805-2.2309 0.86805-3.0114 0l-3.0657-3.4087h9.1429z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-4",
    d: "m15.274 25.143c-5.8911 0-10.667-4.7755-10.667-10.667 0-5.8908 4.7757-10.667 10.667-10.667 5.8911 0 10.667 4.7757 10.667 10.667 0 5.8912-4.7754 10.667-10.667 10.667m-2.65e-5 -25.143c-8.4157 0-15.238 6.4813-15.238 14.476 0 7.9953 6.8224 14.476 15.238 14.476 8.4157 0 15.238-6.481 15.238-14.476 0-7.9948-6.8224-14.476-15.238-14.476"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-7-Copy",
    d: "m22.857 14.476c0 2.1039-1.7055 3.8095-3.8095 3.8095-2.1039 0-3.8095-1.7056-3.8095-3.8095 0-2.1037 1.7056-3.8095 3.8095-3.8095 2.104 0 3.8095 1.7058 3.8095 3.8095"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(70 17)",
    fill: "#1C363C"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    d: "m19.846 28.004-3.0657 3.3555c-0.7805 0.85449-2.2309 0.85449-3.0114 0l-3.0657-3.3555h9.1429z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-4",
    d: "m15.274 25.25c-5.8911 0-10.667-4.7009-10.667-10.5 0-5.7988 4.7757-10.5 10.667-10.5 5.8911 0 10.667 4.7011 10.667 10.5 0 5.7992-4.7754 10.5-10.667 10.5m-2.65e-5 -24.75c-8.4157 0-15.238 6.38-15.238 14.25 0 7.8703 6.8224 14.25 15.238 14.25 8.4157 0 15.238-6.3797 15.238-14.25 0-7.8699-6.8224-14.25-15.238-14.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "19.284 7.44 19.284 10.68 22.444 10.68 22.444 14.02 19.284 14.02 19.284 17.28 15.744 17.28 15.744 14.02 12.604 14.02 12.604 10.68 15.744 10.68 15.744 7.44",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(121 34)",
    fill: "#1C363C"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    d: "m19.846 27.94-3.0657 3.4087c-0.7805 0.86805-2.2309 0.86805-3.0114 0l-3.0657-3.4087h9.1429z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-4",
    d: "m15.274 25.143c-5.8911 0-10.667-4.7755-10.667-10.667 0-5.8908 4.7757-10.667 10.667-10.667 5.8911 0 10.667 4.7757 10.667 10.667 0 5.8912-4.7754 10.667-10.667 10.667m-2.65e-5 -25.143c-8.4157 0-15.238 6.4813-15.238 14.476 0 7.9953 6.8224 14.476 15.238 14.476 8.4157 0 15.238-6.481 15.238-14.476 0-7.9948-6.8224-14.476-15.238-14.476"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-7-Copy",
    d: "m16.762 12.952c0 2.1039-1.7055 3.8095-3.8095 3.8095-2.1039 0-3.8095-1.7056-3.8095-3.8095 0-2.1037 1.7056-3.8095 3.8095-3.8095 2.104 0 3.8095 1.7058 3.8095 3.8095"
  })), /*#__PURE__*/React.createElement("g", {
    id: "e",
    transform: "translate(124.5 15) scale(-1 1) translate(-15.5 -15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-Copy",
    d: "m0.5 29.5h22.5c4.1421 0 7.5-3.3579 7.5-7.5v-14c0-4.1421-3.3579-7.5-7.5-7.5h-15c-4.1421 0-7.5 3.3579-7.5 7.5v21.5z",
    stroke: "#A3A5A7"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#1C363C",
    fontFamily: "AppleColorEmoji, Apple Color Emoji, Segoe UI Emoji",
    fontSize: 15
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 6,
    y: 21
  }, "\uD83D\uDE0A "))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(252.5 15) scale(-1 1) translate(-15.5 -15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-Copy",
    d: "m0.5 29.5h22.5c4.1421 0 7.5-3.3579 7.5-7.5v-14c0-4.1421-3.3579-7.5-7.5-7.5h-15c-4.1421 0-7.5 3.3579-7.5 7.5v21.5z",
    stroke: "#A3A5A7"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#1C363C",
    fontFamily: "AppleColorEmoji, Apple Color Emoji, Segoe UI Emoji",
    fontSize: 15
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 6,
    y: 21
  }, "\uD83D\uDC4D "))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.5 15) scale(-1 1) translate(-26.5 -15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "m9 0h36c4.4183-8.1162e-16 8 3.5817 8 8v14c0 4.4183-3.5817 8-8 8h-44v-22c0-4.4183 3.5817-8 8-8z",
    fill: "#1C363C"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(26.5 18) scale(-1 1) translate(-26.5 -18)",
    fill: "#FFFFFF",
    fontFamily: "FiraSans-Bold, Fira Sans",
    fontSize: 15,
    fontWeight: "bold",
    "line-spacing": 18
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 7,
    y: 21
  }, "Hallo! "))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(177 34)",
    fill: "#1C363C"
  }, /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "m19.846 27.94-3.0657 3.4087c-0.7805 0.86805-2.2309 0.86805-3.0114 0l-3.0657-3.4087h9.1429z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "m15.274 25.143c-5.8911 0-10.667-4.7755-10.667-10.667 0-5.8908 4.7757-10.667 10.667-10.667 5.8911 0 10.667 4.7757 10.667 10.667 0 5.8912-4.7754 10.667-10.667 10.667m-2.65e-5 -25.143c-8.4157 0-15.238 6.4813-15.238 14.476 0 7.9953 6.8224 14.476 15.238 14.476 8.4157 0 15.238-6.481 15.238-14.476 0-7.9948-6.8224-14.476-15.238-14.476"
  }), /*#__PURE__*/React.createElement("path", {
    id: "d",
    d: "m22.762 11.952c0 2.1039-1.7055 3.8095-3.8095 3.8095-2.1039 0-3.8095-1.7056-3.8095-3.8095 0-2.1037 1.7056-3.8095 3.8095-3.8095 2.104 0 3.8095 1.7058 3.8095 3.8095"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8 0h24c4.4183-8.1162e-16 8 3.5817 8 8v14c0 4.4183-3.5817 8-8 8h-32v-22c-5.4108e-16 -4.4183 3.5817-8 8-8z",
    fill: "#1C363C"
  }), /*#__PURE__*/React.createElement("text", {
    fontFamily: "AppleColorEmoji, Apple Color Emoji, Segoe UI Emoji",
    fontSize: 15
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 6,
    y: 21,
    fill: "#1C363C"
  }, "\uD83C\uDF54 "), /*#__PURE__*/React.createElement("tspan", {
    x: 26,
    y: 21,
    fill: "#FFFFFF",
    fontFamily: "FiraSans-Bold, Fira Sans",
    fontWeight: "bold"
  }, "? "))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(253 34)",
    fill: "#1C363C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m19.846 27.94-3.0657 3.4087c-0.7805 0.86805-2.2309 0.86805-3.0114 0l-3.0657-3.4087h9.1429z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.274 25.143c-5.8911 0-10.667-4.7755-10.667-10.667 0-5.8908 4.7757-10.667 10.667-10.667 5.8911 0 10.667 4.7757 10.667 10.667 0 5.8912-4.7754 10.667-10.667 10.667m-2.65e-5 -25.143c-8.4157 0-15.238 6.4813-15.238 14.476 0 7.9953 6.8224 14.476 15.238 14.476 8.4157 0 15.238-6.481 15.238-14.476 0-7.9948-6.8224-14.476-15.238-14.476"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.762 13.952c0 2.1039-1.7055 3.8095-3.8095 3.8095-2.1039 0-3.8095-1.7056-3.8095-3.8095 0-2.1037 1.7056-3.8095 3.8095-3.8095 2.104 0 3.8095 1.7058 3.8095 3.8095"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoConversationsIllustration);
export default __webpack_public_path__ + "static/media/noConversationsIllustration.35a9ec7d52725aca01beaf856f5f5ef7.svg";
export { ForwardRef as ReactComponent };